//* Import libraries
import { useState, useCallback, useEffect } from "react";

//* Import react-router hooks
import { Link, useNavigate } from "react-router-dom";

//* Import components
import { List } from "../../../component/list/list";
import { Loading } from "../../../component/common/Loading";

//* Import custom hooks
import { useDemands } from "../../../hooks/demand/useDemands";

import { Demands } from "../../../hooks/demand/types/types";
import { Button, Form, Spinner, Row, Col } from "react-bootstrap";
import { Attention } from "../../../component/base/Attention";
import ModalQuestao from "../../../component/base/ModalQuestao";

var debounce = require("lodash.debounce");

export function Visibilidade() {
  const token = localStorage.getItem("token") || "";

  const [answers, setAnswers]: any = useState({});

  const [showModal,setShowModal] = useState(false)

  const onchangeInput=(e:any,key:any)=>{
    if(e.target.value!='' && Number.isNaN(e.target.value)){
      return;
    }

    let answers_ = { ...answers }
    answers_[key] =e.target.value==''?'': parseInt(e.target.value)
    setAnswers(answers_)
  }



  return (
    <div className="row">
      <div className="col-12">

        <div className={"py-5 px-3"}>
          <div className={"card-body"} id="card">
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "2.0rem", color: "black" }}
            >
              Visibilidade do status do sistema
            </h4>
            <br></br>
            <br></br>
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Explicação da heurística:
            </h4>
            <br></br>
            <p align="justify"> <strong> Essa heurística determina que, a cada mudança de status que ocorra no software científico, o usuário deve receber uma comunicação sobre o que está acontecendo e
              quais de suas ações são permitidas. Além disso, em períodos de longas esperas, o software deve apresentar uma comunicação que indique o progresso da atividade.
              Exemplo: Ao ser realizado um upload de um arquivo de grande volume, o software deve indicar por uma barra de carregamento qual é a porcentagem atual (o status)
              e quanto falta para atingir o total da ação, ou seja, 100% do upload do arquivo. </strong> </p>
            <p align="justify"> <strong> A heurística Visibilidade do status do software foi subdivida em três critérios de análise, a saber: Comportamento e comunicação do software durante as mudanças
              de status (C1), Comunicação das funções disponíveis para o usuário durante a troca de status (C2) e Comportamento do software durante períodos de longas esperas (C3). </strong> </p>
            <br></br>
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Perguntas para avaliação:
            </h4>
            <br></br>


            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
                P1.C1) Durante a transição de qualquer status do software, como a troca de páginas, carregamento de dados ou atualização de campos de seleção, o software
                comunica que a transição de status está em andamento? Indique o número de transições analisadas (N) e a quantidade de comunicações que são realizadas (Q).
                Exemplo de comunicação: Técnica de Page loading como loading circular e loading em barra, e técnicas de transição entre estados como a habilitação de botão. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de transições analisadas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['1_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'1_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de comunicações realizadas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['1_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'1_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>


            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
                P1.C2)   Durante a transição de qualquer status do software, como a troca de páginas, carregamento de dados ou atualização de campos de seleção, o software
                realiza algum bloqueio total do software? Esse bloqueio é comunicado para o usuário? Indique o número de bloqueios totais (N) e a quantidade de comunicações
                de bloqueios que são realizadas (Q). Exemplo de comunicação de bloqueio total: Ao entrar no status de bloqueio total, o software apresenta uma janela que
                contém uma mensagem amigável que informa para o usuário a necessidade de aguardar com que a ação de bloqueio seja concluída. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de bloqueios totais:  &nbsp; </span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['2_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'2_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de comunicações de bloqueios realizadas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['2_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'2_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
                P2.C2)   Durante a transição de qualquer status do software, como a troca de páginas, carregamento de dados ou atualização de campos de seleção, o software
                realiza algum bloqueio parcial de funções do software? Esse bloqueio é comunicado para o usuário? Indique o número de bloqueios parciais (N) e a quantidade
                de comunicações de bloqueios que são realizadas (Q). Exemplo de comunicação de bloqueio parcial: Ao entrar no status de bloqueio parcial, os botões de
                funções bloqueadas são inativados e mudam de cor. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de bloqueios parciais: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['3_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'3_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de comunicações de bloqueios realizadas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['3_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'3_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
                P1.C3)   Durante os períodos de longa espera, o software comunica ao usuário o que está ocorrendo e apresenta uma estimativa do tempo restante para concluir
                a tarefa? Indique o número de períodos analisados (N) e a quantidade de comunicações realizadas (Q). Exemplo de comunicação: Durante o processamento de uma
                quantidade grande de dados o software informa que o processamento está em andamento e terminará em X unidades de tempo. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de períodos analisados: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['4_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'4_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de comunicações realizadas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['4_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'4_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
                P2.C3)   Durante os períodos de longa espera, o software apresenta informações que comunicam para o usuário o progresso da tarefa que está causando a espera?
                Indique o número de períodos analisados (N) e a quantidade de comunicações realizadas (Q) Exemplo de comunicação: Durante o processamento de uma quantidade
                grande de dados, o software informa a quantidade de dados processados e a quantidade de dados que ainda está na fila de processamento. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de períodos analisados: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['5_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'5_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>quantidade de comunicações realizadas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['5_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'5_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>

            <button onClick={(e) => {
              if(answers['1_1']
                && answers['1_2'] &&
                answers['2_1']
                && answers['2_2'] &&
                answers['3_1']
                && answers['3_2'] &&
                answers['4_1']
                && answers['4_2'] &&
                answers['5_1']
                && answers['5_2']
              ){

                setShowModal(true);
              }
            }} className="btn btn-success btn-lg w-100">
              Gerar resultado
            </button>
            <ModalQuestao answers={answers} showModal={showModal} setShowModal={setShowModal} />













          </div>
        </div>
      </div>

    </div>
  );
}
